var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnArrowLeftWhite = function SvgIcnArrowLeftWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NAV_icn/icn_pre/Light"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2582 3.21373C13.5423 2.92876 14.0028 2.92876 14.2869 3.21373C14.571 3.49871 14.571 3.96075 14.2869 4.24572L5.5287 13.032L4.5 12L13.2582 3.21373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2869 19.7543C14.571 20.0393 14.571 20.5013 14.287 20.7863C14.0029 21.0712 13.5423 21.0712 13.2583 20.7863L4.5 12L5.52874 10.968L14.2869 19.7543Z",
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnArrowLeftWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_arrow_left_white.8ee8a120.svg";
export { ForwardRef as ReactComponent };